<h1 id="step-heading" class="step-heading">
  <% if (AppointmentBooking.config.ask_insurance_update_question) { %>
    <%= I18n.insurance.update_question.heading %>
  <% } else { %>
    <%= I18n.insurance.heading %>
  <% } %>
</h1>

<div class="step-form">
  <div class="insurance-recoverable-error-container"></div>

  <% if (AppointmentBooking.config.ask_insurance_update_question) { %>
    <fieldset class="field insurance-update-response-field">
      <legend class="visually-hidden"><%= I18n.insurance.update_question.heading %></legend>
      <div class="field-content">
        <div class="input-buttons">
          <label class="input-button" data-testid="<%= testIds.registration.insuranceSameAsLastVisit %>">
            <input class="button-state" data-appointment-booking-wizard-behaviour="field-input" type="radio" name="insurance_update_response" value="unchanged" <% if (insurance_update_response === 'unchanged') { %>checked<% } %>>
            <span class="button-content"><%= I18n.insurance.update_question.responses.unchanged %></span>
          </label>
          <label class="input-button" data-testid="<%= testIds.registration.insuranceChanged %>">
            <input class="button-state" data-appointment-booking-wizard-behaviour="field-input" type="radio" name="insurance_update_response" value="changed" <% if (insurance_update_response === 'changed') { %>checked<% } %>>
            <span class="button-content"><%= I18n.insurance.update_question.responses.changed %></span>
          </label>
          <label class="input-button" data-testid="<%= testIds.registration.insuranceSelfPay %>">
            <input class="button-state" data-appointment-booking-wizard-behaviour="field-input" type="radio" name="insurance_update_response" value="self_pay" <% if (insurance_update_response === 'self_pay') { %>checked<% } %>>
            <span class="button-content"><%= I18n.insurance.update_question.responses.self_pay %></span>
          </label>
        </div>
      </div>
    </fieldset>

    <sp-text type="body" class="insurance-update-response-message insurance-update-response-message--unchanged" style="display:none"><%= I18n.insurance.update_question.messages.unchanged %></sp-text>
    <sp-text type="body" class="insurance-update-response-message insurance-update-response-message--self-pay" style="display:none"><%= I18n.insurance.update_question.messages.self_pay %></sp-text>
  <% } %>

  <div class="insurance-form-section field">
    <label class="field-label"><%= I18n.insurance.labels.carrier %></label>
    <div class="field-input select">
      <select data-appointment-booking-wizard-behaviour="field-input" required type="text" name="payor_id" data-testid="<%= testIds.registration.payor %>">
        <option value=""><%= I18n.prompts.carrier %></option>
        <% AppointmentBooking.config.payors.forEach(function(payor) { %>
          <% if (AppointmentBooking.config.ask_insurance_update_question && String(payor.id) === AppointmentBooking.config.special_payors.no_insurance) { return; } %>
          <option value="<%= payor.id %>" <% if (payor_id == payor.id) { %>selected<% } %>><%- payor.name %></option>
        <% }) %>
      </select>
    </div>
    <span class="field-comment"><%= I18n.insurance.comments.carrier %></span>
  </div>

  <div class="no-insurance-callout-container"></div>

  <div class="insurance-form-section">
    <div class="fieldset insurance-details-fields">
      <a class="insurance-details-help-link" data-appointment-booking-wizard-behaviour="show-insurance-details-help" role="button" tabindex="0">
        <%= I18n.insurance.labels.details_help_link_text %>
      </a>

      <div class="insurance-details-help-callout-container"></div>

      <div class="field insurance-name-field">
        <label class="field-label"><%= I18n.insurance.labels.unlisted_name %></label>
        <input class="field-input" data-appointment-booking-wizard-behaviour="field-input" type="text" name="insurance_name" required placeholder="Required" value="<%- insurance_name %>">
        <span class="validation-error"><%= I18n.errors.required_field %></span>
      </div>

      <% if (AppointmentBooking.config.collect_extended_subscriber_insurance_details) { %>
        <div class="field">
          <label class="field-label"><%= I18n.insurance.labels.member_number %></label>
          <input class="field-input" data-appointment-booking-wizard-behaviour="field-input" type="text" name="member_number" data-testid="<%= testIds.registration.memberNumber %>" required placeholder="Required" value="<%- member_number %>">
          <span class="field-comment"><%= I18n.insurance.comments.member_number %></span>
        </div>

        <div class="field">
          <label class="field-label"><%= I18n.labels.optional_label.replace('%{label}', I18n.insurance.labels.group_number) %></label>
          <input class="field-input" data-appointment-booking-wizard-behaviour="field-input" type="text" name="group_number" data-testid="<%= testIds.registration.groupNumber %>" value="<%- group_number %>">
          <span class="field-comment"><%= I18n.insurance.comments.group_number %></span>
        </div>

        <div class="field">
          <input class="field-checkbox" id="subscriber-is-patient" data-appointment-booking-wizard-behaviour="field-input" type="checkbox" name="subscriber_is_patient" <% if (subscriber_is_patient) { %>checked <% } %>value="true" />
          <label class="field-label subscriber-is-patient" for="subscriber-is-patient"><%= I18n.insurance.labels.subscriber_is_patient %></label>
        </div>

        <div class="subscriber-fields" <% if (subscriber_is_patient) { %>style="display:none"<% } %>>
          <div class="field">
            <label class="field-label"><%= I18n.insurance.labels.subscriber_name %></label>
            <input class="field-input" data-appointment-booking-wizard-behaviour="field-input" type="text" name="subscriber_name" required placeholder="Required" value="<%- subscriber_name %>">
            <span class="field-comment"><%= I18n.insurance.comments.subscriber_name %></span>
            <span class="validation-error"><%= I18n.errors.required_field %></span>
          </div>

          <div class="subscriber-date-of-birth-field"></div>

          <div class="field">
            <label class="field-label"><%= I18n.labels.optional_label.replace('%{label}', I18n.insurance.labels.subscriber_id) %></label>
            <input class="field-input" data-appointment-booking-wizard-behaviour="field-input" type="text" name="subscriber_id" value="<%- subscriber_id %>">
            <span class="field-comment"><%= I18n.insurance.comments.subscriber_id %></span>
            <span class="validation-error"><%= I18n.errors.required_field %></span>
          </div>
        </div>
      <% } else { %>
        <div class="field">
          <label class="field-label"><%= I18n.insurance.labels.member_number %></label>
          <input class="field-input" data-appointment-booking-wizard-behaviour="field-input" type="text" name="member_number" data-testid="<%= testIds.registration.memberNumber %>" required placeholder="Required" value="<%- member_number %>">
          <span class="field-comment"><%= I18n.insurance.comments.member_number %></span>
          <span class="validation-error"><%= I18n.errors.required_field %></span>
        </div>

        <div class="field">
          <label class="field-label"><%= I18n.insurance.labels.group_number %></label>
          <input class="field-input" data-appointment-booking-wizard-behaviour="field-input" type="text" name="group_number" data-testid="<%= testIds.registration.groupNumber %>" required placeholder="Required" value="<%- group_number %>">
          <span class="field-comment"><%= I18n.insurance.comments.group_number %></span>
          <span class="validation-error"><%= I18n.errors.required_field %></span>
        </div>
      <% } %>
    </div>
  </div>
</div>
